<template>
  <div v-if="showBanner" class="storage-overage-banner">
    <div class="d-flex align-items-center justify-content-center" style="gap: 0.5rem">
      <feather-icon icon="AlertOctagonIcon" size="14" />
      <span>{{ bannerMessage }}</span>
      <b-button
        variant="light"
        size="sm"
        class="storage-banner-btn"
        @click="goToStorage"
      >
        Kelola Penyimpanan
      </b-button>
    </div>
  </div>
</template>

<script>
import { defineComponent, computed } from '@vue/composition-api'
import { BButton } from 'bootstrap-vue'
import { useStorageQuotaStore } from '@/pinia/storageQuota'
import moment from 'moment'

export default defineComponent({
  name: 'StorageOverageBanner',
  components: { BButton },
  setup(props, { root }) {
    const storageStore = useStorageQuotaStore()

    const showBanner = computed(() => storageStore.showOverageBanner)

    const bannerMessage = computed(() => {
      const usage = storageStore.usage
      if (!usage) return ''

      if (usage.is_blocked) {
        return 'Penyimpanan diblokir! Upload file tidak dapat dilakukan. Hapus file atau tambah kuota segera.'
      }

      if (usage.grace_expires_at) {
        const expiry = moment(usage.grace_expires_at).format('DD MMMM YYYY')
        return `Penyimpanan melebihi batas! Upload diblokir setelah ${expiry}. Segera hapus file atau tambah kuota.`
      }

      return 'Penyimpanan melebihi batas. Segera hapus file lama atau tambah kuota.'
    })

    const goToStorage = () => {
      root.$router.push({ name: 'workspace', query: { tab: 'penyimpanan' } })
    }

    return {
      showBanner,
      bannerMessage,
      goToStorage,
    }
  },
})
</script>

<style lang="scss" scoped>
.storage-overage-banner {
  position: sticky;
  top: 0;
  z-index: 1029;
  padding: 0.35rem 1rem;
  font-size: 0.78rem;
  font-weight: 500;
  text-align: center;
  background: #fce4ec;
  color: #c62828;
  border-bottom: 1px solid rgba(234, 84, 85, 0.3);
}

.storage-banner-btn {
  padding: 0.15rem 0.5rem;
  font-size: 0.72rem;
  font-weight: 600;
  border-radius: 4px;
}
</style>
